.message {
  margin: 12px auto 0;
  width: 100%;
  max-width: 385px;
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 12px;
  border-radius: 4px;
  box-shadow: 0 3px 20px var(--black-at-75);
  color: var(--white);
  background-color: #143467;
  font-family: "Montserrat", sans-serif;
}

